
import React , {Fragment , useContext, useEffect, useState } from 'react';
import { Formik , Form , ErrorMessage, Field, useFormik } from 'formik';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Cropper from 'react-easy-crop';
import { UserContext } from '../../../Context/UserContext.js';
import * as Yup from 'yup';


import "./setting.css" ;






export default function Setting() {
      const navigate = useNavigate();
      const { userToken } = useContext(UserContext);
   
      const [imageSrc, setImageSrc] = useState(null);
      const [crop, setCrop] = useState({ x: 0, y: 0 });
      const [zoom, setZoom] = useState(1);
      const [croppedArea, setCroppedArea] = useState(null); 
      const[adverts , setAdverts] = useState([]) ;
      const header = {
         token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
      }
   
      const onCropComplete = (_, croppedAreaPixels) => {
         setCroppedArea(croppedAreaPixels);
      };
   
      const handleFileChange = (e, setFieldValue) => {
         const file = e.target.files[0];
         if (!file) return;
   
         setFieldValue("file", file);
         const reader = new FileReader();
         reader.onload = () => setImageSrc(reader.result);
         reader.readAsDataURL(file);
      };
   
      const cropImage = async (imageSrc, croppedArea) => {
         const img = new Image();
         img.src = imageSrc;
         await new Promise((r) => (img.onload = r));
   
         const canvas = document.createElement("canvas");
         canvas.width = 1200;
         canvas.height = 685;
         const ctx = canvas.getContext("2d");
   
         ctx.drawImage(
            img,
            croppedArea.x,
            croppedArea.y,
            croppedArea.width,
            croppedArea.height,
            0,
            0,
            1200,
            685
         );
   
         // if (img.width < 1200 || img.height < 685) {
         //    toast.error("الصورة صغيرة جدًا، برجاء اختيار صورة أكبر من 1200×685");
         //    return;
         // }
         return new Promise((resolve) =>
            canvas.toBlob(resolve, 'image/jpeg')
         );
      };
   
      const handleSubmit = async (values, { setSubmitting }) => {
         try {
            const croppedBlob = await cropImage(imageSrc, croppedArea);
            const formData = new FormData();
            formData.append("title", values.title);
            formData.append("message", values.message);
            formData.append("file", croppedBlob, "cropped.jpg");
   
            const headers = {
               'enctype': 'multipart/form-data',
               token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
            };
   
            const { data } = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/advert`, formData, { headers });
   
            toast.success(data.message || "Advert Added");
            navigate("/dashBoard");
   
         } catch (err) {
            toast.error(err.response?.data?.message || "Error while uploading");
         }
   
         setSubmitting(false);
      };
   
      const initialValues = {
         title: "",
         message: "",
         file: null,
      }
   
      const validationSchema = Yup.object().shape({
         title: Yup.string().required("Title Required"),
         message: Yup.string().required("Message Required"),
         file: Yup.mixed().required("Cover Required")
      });




      
      async function getAdverts(){
         await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/advert` ,  {headers:header} )
         .then(({data})=>{
            if(data.message === "success"){
               setAdverts(data.adverts)
            }
         })
         .catch((error)=>{
            toast.error(error.response?.data.message)
         })
      } ;


      async function deleteAdvert(id){
         await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/v1/advert/${id}` ,  {headers:header} )
         .then(({data})=>{
            if(data.message === "success"){
               setAdverts(data.adverts)
               toast.success(`${data.message }  Deleted Advert`) ;
            }
         })
         .catch((error)=>{
            toast.error(error.response?.data.message)
         })
      }



      useEffect(() => {
         getAdverts()
      }, [])
      

   return (
      <Fragment>

         <div className='container'>
            <h1 className='main-header'>Setting</h1>
            <div className='under-header'></div>

            <div className='container-slider'>
               <div className='showAdverts'>
                  {adverts.length > 0 ? 
                     adverts.map((ele)=>
                        <div className='bg-body-secondary rounded-2 my-2 p-2'>
                           <div className='image-advert'>
                              <img src={ele.image} alt="advert" className="w-100" srcset="" />
                           </div>
                           <div className='text-center my-1'>
                              <button onClick={()=>{deleteAdvert(ele._id)}} className='btn btn-danger'>Delete</button>
                           </div>
                        </div>
                     )
                  : ""}
               </div>




               <div className='addAdvert'>
                  <h3 dir='rtl'>أضافة صورة للاعلان</h3>
                  <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                     {({ setFieldValue, isSubmitting }) => (
                        <Form className="m-auto">
                           <div className="mb-3">
                              <label  htmlFor='title'>العنوان</label>
                              <Field type="text"  name="title"  id='title' className="form-control" />
                              <ErrorMessage name="title" component="div" className="text-danger" />
                           </div>

                           <div className="mb-3">
                              <label htmlFor='message'>الرسالة</label>
                              <Field as="textarea" id="message" name="message" placeholder="اكتب وصف الشركة" rows="3" className="form-control"/>                           
                              <ErrorMessage name="message" component="div" className="text-danger" />
                           </div>

                           <div className="mb-3">
                              <label  htmlFor='image'>الصورة</label>
                              <input type="file" accept="image/*" id='image' className="form-control" onChange={(e) => handleFileChange(e, setFieldValue)} />
                              <ErrorMessage name="file" component="div" className="text-danger" />
                           </div>

                           {imageSrc && (
                              <div className="mb-3" style={{ width: 400, height: 200, position: 'relative' }}>
                                 <Cropper
                                    image={imageSrc}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={1200 / 685}
                                    onCropChange={setCrop}
                                    onZoomChange={setZoom}
                                    onCropComplete={onCropComplete}
                                 />
                              </div>
                           )}

                           <div className="text-center mt-4">
                              <button type="submit" disabled={isSubmitting} className="btn bg-main w-50">
                                 {isSubmitting ? <i className="fa fa-spinner fa-spin"></i> : "إضافة"}
                              </button>
                           </div>
                        </Form>
                     )}
                  </Formik>
               </div>
            </div>
         </div>

      </Fragment>
   )
}
